import { Pipe, PipeTransform } from "@angular/core";
import { get } from "lodash-es";
import { appState } from "src/app/core/state";

@Pipe({
  name: "state",
  standalone: false
})
export class StatePipe implements PipeTransform {
  transform(value: string): any {
    return get(appState, value);
  }
}
